import React from 'react';
import { useSelector } from 'react-redux';
import { selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import {
  DPI_5XX_TO_BACKGROUND_DIMENSIONS,
  Nw5xxToAppBackgroundMetrics,
} from '@utils/dimension/appDimensionHelper';
import { allDimensionsListSelector } from '@src/store/common/dimensionList/selectors';
import StaticTableWidget from './StaticTable';

function Nw5xxToBackgroundDimensionWidget() {
  const selectedMetric = useSelector(selectedMetricSelector);
  if (!Nw5xxToAppBackgroundMetrics.includes(selectedMetric)) {
    return null;
  }
  return (
    <>
      {DPI_5XX_TO_BACKGROUND_DIMENSIONS.map((options) => {
        return (
          <DimensionTableWidget
            header={options.header}
            dimension={options.dimension}
            key={options.dimension}
          />
        );
      })}
    </>
  );
}

const DimensionTableWidget: React.FC<{ header: string; dimension: string }> = (props) => {
  const { header, dimension } = props;

  const supportedDimension = useSelector(allDimensionsListSelector) as any[];
  // disable drill down if this dimension is not in supported dimension list
  const disableDrilldown = supportedDimension.every((it) => it.groupBy !== dimension);

  return (
    <StaticTableWidget header={header} dimension={dimension} disableDrilldown={disableDrilldown} />
  );
};

export default Nw5xxToBackgroundDimensionWidget;
